module.exports = __webpack_public_path__ + "img/09.dda70628.jpg";